import { AgGridReact } from "@ag-grid-community/react";
import { Box } from "@chakra-ui/react";
import { dataAttr } from "@chakra-ui/utils";
import clsx from "clsx";
import { GenericTableRow } from "gen/model/genericTableRow";
import React from "react";
import { DataTableProps } from "shared/components/table/data/DataTableProps";
import { useDataTableAgReactProps } from "shared/components/table/data/internal/ag-props/DataTableAgProps";
import { useBuildDataTableContext } from "shared/components/table/data/internal/DataTableContextBuilder";
import { useDataTableForm } from "shared/components/table/data/internal/DataTableForm";
import { useMaybernTableUIContext } from "shared/components/table/maybern/MaybernTableUIContext";
import { useDetectRenderLoop } from "shared/utils/ReactUtils";

export const DataTable: React.FC<DataTableProps> = (props) => {
  useDetectRenderLoop();

  const { fillWidth, size, sx, data } = props;

  const { getForm } = useDataTableForm(data);
  const { agGridRef, isReady } = useMaybernTableUIContext();
  const context = useBuildDataTableContext(props, getForm);
  const agGridProps = useDataTableAgReactProps(props, context);

  return (
    <Box
      data-ls-enabled={dataAttr(true)}
      sx={sx}
      className={clsx({
        "ag-theme-maybern": true,
        "mb-datatable-box": true,
        "mb-datatable-size-comfortable": size === "comfortable",
        "mb-datatable-fill-width": fillWidth,
        "mb-datatable-ready": isReady,
        "mb-datatable-not-ready": !isReady,
        "mb-datatable-empty": !props.data.rows.length,
        "mb-datatable-selection-without-checkboxes":
          props.rowSelectionCheckboxes === false,
      })}
    >
      <AgGridReact<GenericTableRow> ref={agGridRef} {...agGridProps} />
    </Box>
  );
};
